import { useRouter } from 'next/router'

import ThemeProvider from 'lib/theme/ThemeProvider'

export default function withOrganizationTheme<P extends object>(
  WrappedComponent: React.ComponentType<P>
) {
  const WithOrganizationTheme = (props: P) => {
    const router = useRouter()
    const { organizer: organizerSeoName } = (router.query || {}) as {
      organizer?: string
    }
    return (
      <ThemeProvider organizerSeoName={organizerSeoName}>
        <WrappedComponent {...props} />
      </ThemeProvider>
    )
  }
  return WithOrganizationTheme
}
